import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const OpenMenu = styled(Button)(({ theme }) => ({
  width: 180,
  justifyContent: 'flex-start',
  position: 'relative',
  fontWeight: 'bold',

  '& .more': {
    position: 'absolute',
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    color: theme.palette.primary.light,
    textTransform: 'lowercase',
  },
}));

export const RpRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const CenterRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

export const MobileButtonRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(1),
}));

export const Photo = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  cursor: 'pointer',

  '& .data': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.2)',
    left: 0,
    right: 0,
    bottom: 0,
    height: 40,
    padding: 2,
    color: 'white',

    '& .title': {
      display: 'inline-block',
      textOverflow: 'ellipsis',
      position: 'relative',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      left: 0,
      width: 'calc(100% - 28px)',
    },

    '& .subtitle': {
      display: 'inline-block',
      textOverflow: 'ellipsis',
      position: 'relative',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      left: 24,
      fontSize: 14,
      width: 'calc(100% - 28px)',
    },

    '& .iconWrap': {
      width: 24,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',

      '& .MuiIcon-root': {
        fontSize: 20,
      },
    },
  },

  '& .IMAGE': {
    width: '100% !important',
    height: `100% !important`,

    '& img': {
      top: `0 !important`,
      left: '0 !important',
      width: '100% !important',
      height: '100% !important',
    },
  },
});

export const HlRow = styled('div', {
  shouldForwardProp: (prop) => !['isMobile', 'canSelect'].includes(prop),
})(({ theme, isMobile, canSelect }) => ({
  minHeight: isMobile ? undefined : 120,
  position: 'relative',
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),

  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'flex-start' : 'center',

  '&:hover': {
    backgroundColor: canSelect ? undefined : 'rgba(0,0,0,0.1)',
    cursor: canSelect ? undefined : 'pointer',
  },

  '& .loadingMask': {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& .hlRow': {
    width: isMobile ? '100%' : '20%',
    fontSize: 14,
    marginTop: isMobile ? theme.spacing(4) : theme.spacing(2),

    '& .templateTitle': {
      fontStyle: 'italic',
    },
  },

  '& .hlContent': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  },

  '& .imageListContainer': {
    width: '75%',
    display: 'flex',
    overflow: 'hidden',
    overflowX: 'auto',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
  },

  '& .title': {
    top: theme.spacing(1),
    fontSize: 20,
    fontWeight: 'bold',
  },
}));

export const CaptionContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: '100%',
  '& .link': {
    color: theme.palette.secondary.main,
    fontStyle: 'italic',
    cursor: 'pointer',
    margin: `${theme.spacing(1)} 0`,

    '&.small': {
      fontSize: 12,
    },
  },

  '& .headerRow': {
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: isMobile ? 'flex-start' : 'center',
    fontSize: isMobile ? 12 : 16,
  },

  '& .description': {
    fontSize: 12,
  },
}));

export const Spacer = styled('span')(({ theme }) => ({
  margin: `0 ${theme.spacing(2)}`,
}));

export const MobileDescriptContainer = styled('div')({});
